module.exports = __webpack_public_path__ + "img/activity_other12.9609f134.jpg";